import * as React from 'react';
import Status from '../../../core/types/Status';
import Modal from '../../../core/components/Modal/Modal';
import { PaymentProviderListVM } from '../../types/PaymentProviderListVM';
// @ts-ignore
import styles from './PayAllCustomerTransactionsTile.module.scss';
import { PaymentProviderType } from '../../types/PaymentProviderType';
import { InfoMessageService, TranslationService } from '../../../core/services';
import ApiProvider from '../../../core/api/ApiProvider';
import { Loader, ModuleContainer } from '../../../core/components';
import { PayableItem } from './types/PayableItem';

type Props = {
  selectedItem: PayableItem;
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onPay: (providerId: PaymentProviderType) => void;
};

const ProvidersModal = (props: Props) => {
  const { selectedItem, isOpen, onToggle, onPay } = props;
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [model, setModel] = React.useState<PaymentProviderListVM>({} as PaymentProviderListVM);

  const getAvailablePaymentProviders = async () => {
    return await ApiProvider.get<Status<PaymentProviderListVM>>(
      `PayAllCustomerTransactionsTileModule/GetAvailablePaymentProviders`
    );
  };

  const fetchData = async () => {
    try {
      const data = await getAvailablePaymentProviders();
      setModel(data.data);
      if (!data.success) {
        InfoMessageService.error(data.message);
        onToggle(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchData();
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onToggle={onToggle}
        className={styles.modalWrapper}
        closeBtnClass="modal-close-btn"
      >
        <ModuleContainer classNames="mt-0 mb-0" variant={ModuleContainer.ModuleVariant.Variant1}>
          <ModuleContainer.Header title={TranslationService.translate('ChooseProvider')} />
          {isLoading && <Loader opacity={0.4} />}
          <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
            {model.paymentProviders &&
              model.paymentProviders.map((provider) => {
                return (
                  <button
                    key={provider.type}
                    onClick={() => {
                      setIsLoading(true);
                      onPay(provider.type);
                    }}
                    id={`PayWith_${PaymentProviderType[provider.type]}`}
                    className={styles.providersTile}
                    disabled={isLoading}
                  >
                    <img src={provider.logo} className={styles.providersLogo} alt="Logo"/>
                  </button>
                );
              })}
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>
    </>
  );
};

export default ProvidersModal;
